import hasClass from './hasClass';
function addClass(element, classAddStr) {
  if (!hasClass(element, classAddStr)) {
    element.className += " ".concat(classAddStr);
  }
}
export default addClass;